export default "__VITE_ASSET__BSAwN216__"